import { useCallback } from "react";
import { useLogger } from "../useLogger/useLogger";

declare global {
  interface Window {
    ReactNativeWebView: any;
    acquisitionpage: string;
  }
}

export const useWebview = () => {
  const { log } = useLogger();

  const postMessage = useCallback(
    (message: "success" | "error") => {
      if (window.ReactNativeWebView) {
        log("log", "useWebview.tsx", "Sending message for webview...", message);
        window.ReactNativeWebView.postMessage(message);
      } else {
        log(
          "log",
          "useWebview.tsx",
          "Not in a ReactNativeWebView. Message not sent"
        );
      }
    },
    [log]
  );

  return { postMessage };
};
